import { useState } from 'react';
import { ScanIcon } from '@/pages/fulfillment/components/UltimateIcons';

export interface BarcodeScan {
  code: string;
  at: string;
  worker: string;
}

/** The desk keeps twenty on screen, for the current day, in this browser only. */
export const ON_SCREEN = 20;

export interface LiveBarcodeFeedProps {
  scans: BarcodeScan[];
}

/**
 * What the desk has scanned, bottom-left and collapsed by default — it confirms the scanner is
 * firing without taking room from the order the operator is actually working.
 */
export function LiveBarcodeFeed({ scans }: LiveBarcodeFeedProps) {
  const [open, setOpen] = useState(false);

  return (
    <aside className={`scanfloat${open ? '' : ' collapsed'}`} aria-label="Live Barcode Feed">
      <button type="button" onClick={() => setOpen((was) => !was)}>
        <ScanIcon />
        Live Barcode Feed <span className="count">{scans.length}</span>
        <span className="caret">{open ? '▾' : '▴'}</span>
      </button>
      <ul>
        {scans.map((scan, index) => (
          <li key={`${scan.at}-${scan.code}-${index}`}>
            <b>{scan.worker}</b>
            <span className="num">{scan.code}</span>
            <time>{scan.at}</time>
          </li>
        ))}
      </ul>
      <footer>Max {ON_SCREEN} on screen · today&apos;s scans kept in this browser</footer>
    </aside>
  );
}
